var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.36H2C1.59 13.36 1.25 13.02 1.25 12.61C1.25 12.2 1.59 11.86 2 11.86H19C19.41 11.86 19.75 12.2 19.75 12.61C19.75 13.02 19.41 13.36 19 13.36Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 21.75H5.78003C2.35003 21.75 1.25 20.6601 1.25 17.2701V10.28C1.25 7.59005 1.86002 6.00005 4.96002 5.82005C5.22002 5.81005 5.49003 5.80005 5.78003 5.80005H15.22C18.65 5.80005 19.75 6.89005 19.75 10.28V17.43C19.71 20.7001 18.61 21.75 15.22 21.75ZM5.78003 7.30005C5.51003 7.30005 5.26003 7.31005 5.03003 7.32005C3.24003 7.43005 2.75 7.81005 2.75 10.28V17.2701C2.75 19.83 3.17003 20.25 5.78003 20.25H15.22C17.8 20.25 18.22 19.85 18.25 17.42V10.28C18.25 7.72005 17.83 7.30005 15.22 7.30005H5.78003Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.18C18.81 18.18 18.62 18.11 18.49 17.98C18.34 17.84 18.25 17.64 18.25 17.43V10.28C18.25 7.72 17.83 7.3 15.22 7.3H5.78003C5.51003 7.3 5.26003 7.31 5.03003 7.32C4.83003 7.33 4.62998 7.25 4.47998 7.11C4.32998 6.97 4.25 6.77 4.25 6.56C4.29 3.3 5.39003 2.25 8.78003 2.25H18.22C21.65 2.25 22.75 3.34 22.75 6.73V13.72C22.75 16.41 22.14 18 19.04 18.18C19.03 18.18 19.01 18.18 19 18.18ZM5.78003 5.8H15.22C18.65 5.8 19.75 6.89 19.75 10.28V16.6C20.91 16.39 21.25 15.79 21.25 13.72V6.73C21.25 4.17 20.83 3.75 18.22 3.75H8.78003C6.50003 3.75 5.91003 4.06 5.78003 5.8Z",
    fill: "#4F5B92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96027 18.5601H5.24023C4.83023 18.5601 4.49023 18.2201 4.49023 17.8101C4.49023 17.4001 4.83023 17.0601 5.24023 17.0601H6.96027C7.37027 17.0601 7.71027 17.4001 7.71027 17.8101C7.71027 18.2201 7.38027 18.5601 6.96027 18.5601Z",
    fill: "#4F5B92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5499 18.5601H9.10986C8.69986 18.5601 8.35986 18.2201 8.35986 17.8101C8.35986 17.4001 8.69986 17.0601 9.10986 17.0601H12.5499C12.9599 17.0601 13.2999 17.4001 13.2999 17.8101C13.2999 18.2201 12.9699 18.5601 12.5499 18.5601Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.ac1c5ac8c70f8fcf00c512e4767fb674.svg";
export { ForwardRef as ReactComponent };